import Component from "../abstracts/Component";

export default class CountdownComponent extends Component {
  get SELECTORS() {
    return {
      main: '.js-countdown',
      now: '[data-date-now]',
      end: '[data-date-end]',
      timeValue: '.js-time-value',
      endMessageContainer: '.js-time-end',
      countdownContainer: '.js-countdown',
      checkboxGroup: '.checkboxes-group',
      inputEmail: '.js-email-input',
      privacy: '.js-wrapper-privacy',
      formCountdown: '.js-countdown-form',
    }
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  startCountdown(){
    let now = $(this.SELECTORS.now).data('dateNow');
    let end = $(this.SELECTORS.end).data('dateEnd');
    let container = document.querySelector(this.SELECTORS.timeValue);
    let endDate = Date.parse(end);
    let currentDate = Date.parse(now);

    if( currentDate < endDate ) {
      document.querySelector(this.SELECTORS.countdownContainer).classList.remove('d-none');
      const countdown = setInterval(() => {
        let distance, days, hours, minutes, seconds;

        currentDate = currentDate + 1000;
        distance = endDate - currentDate;

        // calculations
        days = Math.floor(distance / (1000 * 60 * 60 * 24));
        hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        seconds = Math.floor((distance % (1000 * 60)) / 1000);

        container.querySelector('.js-countdown-days').innerHTML = days;
        container.querySelector('.js-countdown-hours').innerHTML = hours;
        container.querySelector('.js-countdown-minutes').innerHTML = minutes;

        if (distance < 0) {
          clearInterval(countdown);
          container.innerHTML = "";
          container.classList.add('d-none');
          document.querySelector(this.SELECTORS.endMessageContainer).classList.remove('d-none');
          document.querySelector(this.SELECTORS.formCountdown).classList.add('d-none');
        }

      }, 1000)
    } else{
      document.querySelector(this.SELECTORS.endMessageContainer).classList.remove('d-none');
      document.querySelector(this.SELECTORS.formCountdown).classList.add('d-none');
    }
  }

  bindEmailCountdown() {
    let ctx = this;
    $('body').on('focus.countdown', ctx.SELECTORS.inputEmail, function (e) {
      let checkboxes = $(ctx.SELECTORS.checkboxGroup);
      checkboxes.addClass(ctx.CLASSES.show);
    });

    // force validation on change
    $('body').on('focusout.countdown', ctx.SELECTORS.inputEmail, function (e) {
      document.newsletterBouncer.validate(this);
      const $email = $(this);
      ctx.updateSubmitButton($email);
    });

    $('body').on('click.countdownprivacy', ctx.SELECTORS.privacy, function (e) {
      const $email = $(this);
      ctx.updateSubmitButton($email);
    });

    $('body').on('submit','.js-countdown-form', function (e) {
      e.preventDefault();
      let  $form = $(this).serialize();

      $.ajax({
        url: '/action/ajax/countdown-component',
        type : 'POST',
        data : $form,
        success: function(result){
          $('.js-countdown-email-wrapper').append(result);
        }}
      );

    });
  }

  updateSubmitButton ($email) {
    let emailHasError = $email.hasClass( "error" );
    let form = $email.closest('form');

    let $privacy = form.find(this.SELECTORS.privacy);
    let id = $privacy.attr('id');
    let basicNewsletterSubmit = document.querySelector('button[data-target="' + id + '"]');
    let checked = $privacy.is(':checked');

    if (checked && !emailHasError) {
      $(basicNewsletterSubmit).prop('disabled', false);
    } else {
      $(basicNewsletterSubmit).prop('disabled', true);
    }
  };

  bindEvents() {
    this.startCountdown();
    this.bindEmailCountdown();
  }

  render() {
    if (document.querySelector(this.SELECTORS.main)) this.bindEvents();
  }

}
